import React from 'react'

const SvgShieldUserFill = (props: any) => (
  <svg width={32} height={32} {...props}>
    <g fill="none" fillRule="evenodd">
      <path d="M4 4h24v24H4z" />
      <path
        d="M7.783 6.826L16 5l8.217 1.826a1 1 0 01.783.976v9.987a6 6 0 01-2.672 4.992L16 27l-6.328-4.219A6 6 0 017 17.79V7.802a1 1 0 01.783-.976zM16 15a2.5 2.5 0 000-5 2.5 2.5 0 000 5zm-4.473 5h8.946a4.5 4.5 0 00-8.946 0z"
        fillOpacity={0.64}
        fill="#191923"
        fillRule="nonzero"
      />
    </g>
  </svg>
)

export default SvgShieldUserFill
